import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Role } from "../../../../../../models/role";
import { RoleStatus } from "../../../../../../models/role-status";
import { RoleStatusControllerService } from "../../../../../../services/role-controller/role-status-controller.service";
import { Store } from "../../../../../../services/store.service";
import { BaseError } from "../../../../base-error";
import { RoleDetailComponent } from "../../../role-detail.component";

@Component({
  selector: "status-new",
  templateUrl: "./status-new.component.html",
  providers: [RoleStatusControllerService],
})
export class StatusNewComponent extends BaseError {
  @Input() public role: Role;
  @Input() public destinations: Role[];
  @Input() public roleStatus = new RoleStatus();

  public modalOpen: boolean;
  public allRoles: any[];
  public selectedRoles: any[] = [];
  public displayModal: any = false;
  public hideContent: boolean = false;

  public isLoading: boolean = false;

  @Output() public editCancel = new EventEmitter();

  constructor(private roleStatusService: RoleStatusControllerService,
              public store: Store,
              private roleDetail: RoleDetailComponent, toastr: ToastrService) {
    super(toastr);
  }

  public ngOnChanges() {
    this.prepareSelectDestinationsList();
  }

  public prepareSelectDestinationsList() {
    if (this.role && this.destinations && this.destinations.length) {
      this.allRoles = this.destinations.filter((item) => this.role.id !== item.id).map((item) => {
        return { id: item.id, text: item.name };
      });
    }
  }

  public removed(value: any): void {
    if (this.selectedRoles) {
      for (let i = 0; i < this.selectedRoles.length; i++) {
        if (this.selectedRoles[i].id === value.id) {
          this.selectedRoles.splice(i, 1);
          break;
        }
      }
    }
  }

  public selected(value: any): void {
    if (this.selectedRoles === undefined) {
      this.selectedRoles = [];
    }
    this.selectedRoles.push(value);
  }

  public createRoleFileValidatedStatus(roleId: string) {
    if (!this.isLoading) {
      this.roleStatus.destinations = this.selectedRoles.map((item) => {
        return { destinationId: item.id };
      });
      this.roleStatusService.createRoleUserDefinedStatus(roleId, this.roleStatus).subscribe(
        (data) => {
          this.responseSuccessful("Status added!");
          this.closeLayer();
        },
        (error) => this.showErrorMessage(error),
        () => this.isLoading = false,
      );
    }
  }

  public resetForm() {
    this.selectedRoles = undefined;
  }

  public toggleContent() {
    this.hideContent = !this.hideContent;
  }

  public closeLayer() {
    this.editCancel.emit({ cancel: true });
  }

}
